import { GridRowId, GridSortModel } from '@mui/x-data-grid-pro';
import { useCallback, useEffect, useState } from 'react';

interface UseDeviceTableStateOptions {
  initialExpandedRowIds?: GridRowId[];
  allowExpandedCount?: number;
}

const useDeviceTableState = ({
  initialExpandedRowIds,
  allowExpandedCount,
}: UseDeviceTableStateOptions = {}) => {
  const [expandedRowIds, setExpandedRowIds] = useState<GridRowId[]>(
    initialExpandedRowIds ?? [],
  );
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: 'name', sort: 'asc' },
  ]);

  const handleExpandedRowsChange = useCallback(
    (newIds: GridRowId[]) => {
      if (allowExpandedCount && newIds.length > allowExpandedCount) {
        setExpandedRowIds(newIds.slice(-1 * allowExpandedCount));
      } else {
        setExpandedRowIds(newIds);
      }
    },
    [allowExpandedCount],
  );

  useEffect(() => {
    if (initialExpandedRowIds) {
      setExpandedRowIds(initialExpandedRowIds);
    }
  }, [initialExpandedRowIds]);

  return {
    expandedRowIds,
    sortModel,
    onExpandedRowsChange: handleExpandedRowsChange,
    onSortModelChange: setSortModel,
  };
};

export default useDeviceTableState;
